var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.00100007C5.0336 -0.0101531 4.56968 0.072078 4.13552 0.242856C3.70137 0.413634 3.30575 0.669511 2.97194 0.995434C2.63813 1.32136 2.37287 1.71075 2.19176 2.14069C2.01065 2.57064 1.91735 3.03246 1.91735 3.499C1.91735 3.96554 2.01065 4.42736 2.19176 4.85731C2.37287 5.28725 2.63813 5.67664 2.97194 6.00257C3.30575 6.32849 3.70137 6.58437 4.13552 6.75514C4.56968 6.92592 5.0336 7.00815 5.5 6.997C5.9664 7.00815 6.43032 6.92592 6.86448 6.75514C7.29863 6.58437 7.69425 6.32849 8.02806 6.00257C8.36187 5.67664 8.62713 5.28725 8.80824 4.85731C8.98935 4.42736 9.08265 3.96554 9.08265 3.499C9.08265 3.03246 8.98935 2.57064 8.80824 2.14069C8.62713 1.71075 8.36187 1.32136 8.02806 0.995434C7.69425 0.669511 7.29863 0.413634 6.86448 0.242856C6.43032 0.072078 5.9664 -0.0101531 5.5 0.00100007ZM3.5 8.995C2.57174 8.995 1.6815 9.36375 1.02513 10.0201C0.368749 10.6765 0 11.5667 0 12.495V14.992H11V12.495C11 11.5667 10.6313 10.6765 9.97487 10.0201C9.3185 9.36375 8.42826 8.995 7.5 8.995H3.5Z",
    fill: "#AD2F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.e78d4964da092dbedfeeb3d377725052.svg";
export { ForwardRef as ReactComponent };